import React, { useEffect } from 'react'
import style from "css/template.module.css";

function MobileMenuItem({ title, child, menuType, setMenuType }) {
    const [isOpen, setIsOpen] = React.useState(false);

    useEffect(() => {
        if (!isOpen && menuType === title) {
            setIsOpen(true);
        } else if (isOpen && menuType !== title) {
            setIsOpen(false);
        }
    }, [isOpen, menuType, setMenuType, title]);

    const onClickMenu = () => {
        if (!isOpen) {
            setMenuType(title);
        } else {
            setMenuType("");
        }
    }

    return (
        <li className={style.menu_item}>
            <div className={style.menu_info} onClick={() => onClickMenu()}>
                <p>{title}</p>
                <img
                    className={isOpen && style.open}
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                    alt=""
                />
            </div>

            {isOpen && <div className={style.menu_child}>{child}</div>}
        </li>
    )
}

export default MobileMenuItem
